import { useInstanceSettingsStore } from "#src/stores/instance-settings.js";
import { useQuotingStore } from "#src/stores/quoting.js";
import { useStepQuoteStore } from "#src/stores/step-quote.js";
import { parseErrorMessage } from "#src/util/helpers.js";

export class QuotingService {
  #pinia;

  constructor(pinia) {
    this.#pinia = pinia;
  }

  async getQuotesFromPrefill({ strictParams = false } = {}) {
    const quoting = useQuotingStore(this.#pinia);
    const instance = useInstanceSettingsStore(this.#pinia);

    // require only 1 available product or prefilled type
    if (instance.available.length > 1 && !quoting.params.selected_type) {
      const available = Object.keys(instance.products).filter(
        v => instance.products[v]
      );
      throw {
        selected_type: [
          `Please provide selected_type: ${available.join(", ")}`,
        ],
      };
    }

    if (strictParams) {
      const validate = await import(
        "#src/structures/quote-params/QuoteParameterValidation.js"
      );
      const validation = validate.quoteSetDefaultsAndValidate(
        this.#pinia,
        quoting.params
      );
      validate.enforceStrictParameterValidation(validation);
    }

    return this.getQuotes();
  }

  async getQuotes() {
    const quoteStep = useStepQuoteStore(this.#pinia);
    const returnData = {
      defaultQuote: null,
      quotes: [],
    };

    try {
      quoteStep.prequoteSetup();
      returnData.defaultQuote = await quoteStep.fetchAppQuotes();
      returnData.quotes = quoteStep.quotes;
    } catch (e) {
      throw { error: [parseErrorMessage(e)] };
    }

    return returnData;
  }
}
